/* EoxBulletinViewComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./EoxBulletinViewRenderer");
const componentEoxDateColumn = require("./column_renderers/date_column/DateComponent");
const phoneModelColumn = require("./column_renderers/phone_model_column/PhoneModelComponent");

const PagingCompEoxFeed = require("./EoxBulletinViewFeed");
const PagingPhoneModelEoxFeed = require("./PhoneModelEoxFeed");

class EoxBulletinViewComponent extends EventEmitter {
    constructor(
        logger,
        gameEditor,
        userSession,
        CustomFieldsEntity,
        MUF,
        storageFactory,
        solutionsManager
    ) {
        super();
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = MUF;
        this._userSession = userSession;
        this._solutionDefinition = solutionsManager.getActiveSolution();
        this._solutionName = this._solutionDefinition.name || "";
        this._device = undefined;
        this._deviceEox = undefined;
        this._componentEox = undefined;
        this._compPagingFeed = undefined;
        this._phoneModelPagingFeed = undefined;
        this._gameEditor.getTabCmpnt().setDirty(false);
        this._renderer = new Renderer(this);

        this._gridKey = _.camelCase(this._solutionName) + "_" + "advisoryView";
        this._userGridData = storageFactory.getRemoteStorageInstanceForEntityGrid(
            "entity_grid_gl",
            this._gridKey
        );

        this.columnConfig = {
            EOLProductID: {
                label: "Product ID",
                path: "data.EOLProductID",
                //columnRendererComponent: ,
                sort: "asc",
                priority: 1,
                width: 120,
            },
            ProductIDDescription: {
                label: "Description",
                path: "data.ProductIDDescription",
                //columnRendererComponent: ,
                sort: "asc",
                priority: 2,
                width: 280,
            },
            ProductBulletinNumber: {
                label: "Bulletin Number",
                path: "data.ProductBulletinNumber",
                priority: 3,
            },
            EOXExternalAnnouncementDate: {
                label: "Announcement",
                path: "data.EOXExternalAnnouncementDate.value",
                columnRendererComponent: componentEoxDateColumn,
                sort: "asc",
                priority: 4,
                width: 100,
            },
            EndOfSaleDate: {
                label: "EoS",
                description: "End of Sale Date",
                path: "data.EndOfSaleDate.value",
                columnRendererComponent: componentEoxDateColumn,
                sort: "asc",
                priority: 4,
                width: 100,
            },
            EndOfSWMaintenanceReleases: {
                label: "EoSMR",
                description: "End of Software Maintenance Release",
                path: "data.EndOfSWMaintenanceReleases.value",
                columnRendererComponent: componentEoxDateColumn,
                sort: "asc",
                priority: 4,
                width: 100,
            },
            EndOfSecurityVulSupportDate: {
                label: "EoSS",
                description: "End of Security Vulnerability Support Date",
                path: "data.EOXExternalAnnouncementDate.value",
                columnRendererComponent: componentEoxDateColumn,
                sort: "asc",
                priority: 4,
                width: 100,
            },
            EndOfRoutineFailureAnalysisDate: {
                label: "EoRFA",
                description: "End of Routine Failure Analysis Date",
                path: "data.EOXExternalAnnouncementDate.value",
                columnRendererComponent: componentEoxDateColumn,
                sort: "asc",
                priority: 4,
                width: 100,
            },
            EndOfServiceContractRenewal: {
                label: "EoCR",
                description: "End of Service Contract Renewal",
                path: "data.EndOfServiceContractRenewal.value",
                columnRendererComponent: componentEoxDateColumn,
                sort: "asc",
                priority: 4,
                width: 100,
            },
            LastDateOfSupport: {
                label: "LDS",
                description: "Last Date of Support",
                path: "data.LastDateOfSupport.value",
                columnRendererComponent: componentEoxDateColumn,
                sort: "asc",
                priority: 4,
                width: 100,
            },
            EndOfSvcAttachDate: {
                label: "EoSA",
                description: "End of Service Attach Date",
                path: "data.EndOfSvcAttachDate.value",
                columnRendererComponent: componentEoxDateColumn,
                sort: "asc",
                priority: 4,
                width: 100,
            },
        };

        this.phoneModelColumnConfig = {
            model: {
                label: "Model",
                path: "data.EOLProductID",
                columnRendererComponent: phoneModelColumn,
                // sort: "asc", // update sorting once model is available from eox entity
                priority: 1,
                width: 150,
                sortable: false,
            },
            EOLProductID: {
                label: "Reference PID",
                path: "data.EOLProductID",
                sort: "asc",
                priority: 2,
                width: 215,
            },
            ProductIDDescription: {
                label: "Description",
                path: "data.ProductIDDescription",
                priority: 3,
                width: 495,
            },
            ProductBulletinNumber: {
                label: "Bulletin Number",
                path: "data.ProductBulletinNumber",
                priority: 4,
                width: 150,
            },
            EndOfSaleDate: {
                label: "EoS",
                description: "End of Sale Date",
                path: "data.EndOfSaleDate.value",
                columnRendererComponent: componentEoxDateColumn,
                sort: "asc",
                priority: 5,
                width: 125,
            },
            EndOfSWMaintenanceReleases: {
                label: "EoSMR",
                description: "End of SW Maintenance Releases",
                path: "data.EndOfSWMaintenanceReleases.value",
                columnRendererComponent: componentEoxDateColumn,
                sort: "asc",
                priority: 6,
                width: 125,
            },
            EndOfRoutineFailureAnalysisDate: {
                label: "EoRFA",
                description: "End of Routing Failure Analysis Date",
                path: "data.EndOfRoutineFailureAnalysisDate.value",
                columnRendererComponent: componentEoxDateColumn,
                sort: "asc",
                priority: 7,
                width: 125,
            },
            EndOfSecurityVulSupportDate: {
                label: "EoSS",
                description: "End of Security Support Date",
                path: "data.EndOfSecurityVulSupportDate.value",
                columnRendererComponent: componentEoxDateColumn,
                sort: "asc",
                priority: 8,
                width: 125,
            },
            LastDateOfSupport: {
                label: "LDS",
                description: "Last Day of Support",
                path: "data.LastDateOfSupport.value",
                columnRendererComponent: componentEoxDateColumn,
                sort: "asc",
                priority: 9,
                width: 125,
            },
            EndOfSvcAttachDate: {
                label: "EoSA",
                description: "End of Svc Attach Date",
                path: "data.EndOfSvcAttachDate.value",
                columnRendererComponent: componentEoxDateColumn,
                sort: "asc",
                priority: 10,
                width: 120,
            },
        };
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        if (!_.isUndefined(this._device)) {
            this._device.on(
                "PristinePropertiesChanged",
                (this._onPristinePropertiesChanged = this._onPristinePropertiesChanged.bind(this))
            );
        }
        if (!_.isUndefined(this._deviceEox)) {
            this._deviceEox.on(
                "PristinePropertiesChanged",
                (this._onPristinePropertiesChanged = this._onPristinePropertiesChanged.bind(this))
            );
        }
    }

    _unregisterListeners() {
        if (!_.isUndefined(this._device)) {
            this._device.removeListener(
                "PristinePropertiesChanged",
                this._onPristinePropertiesChanged
            );
        }
        if (!_.isUndefined(this._deviceEox)) {
            this._deviceEox.removeListener(
                "PristinePropertiesChanged",
                this._onPristinePropertiesChanged
            );
        }
    }

    _patchSorting(sorting) {
        let patchedSorting = _.clone(sorting);
        if (
            patchedSorting &&
            Object.keys(patchedSorting).length === 1 &&
            !patchedSorting.firstPublished
        ) {
            patchedSorting.firstPublished = -1;
        }
        return patchedSorting;
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    whenFeedReady() {
        return this._compPagingFeed.whenFeedReady();
    }

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        const shutdownPromises = [this._compPagingFeed.shutdown(), this._renderer.shutdown()];
        if (this._phoneModelPagingFeed) {
            shutdownPromises.push(this._phoneModelPagingFeed.shutdown());
        }
        return Promise.all(shutdownPromises).then(
            () => {
                this._modalUserFeedback = undefined;
                this._userSession = undefined;
                this._solutionDefinition = undefined;
                this._solutionName = undefined;
                this._device = undefined;
                this._deviceEox = undefined;
                this._componentEox = undefined;
                this._logger = undefined;
                this._gameEditor = undefined;
                this._renderer = undefined;
                this._compPagingFeed = undefined;
                this._phoneModelPagingFeed = undefined;
            },
            (err) => {
                this._logger.warn(err, "EoxBulletinViewComponent.shutdown() error.");
            }
        );
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onPristinePropertiesChanged(pristineProperties, before) {
        this.emit("PristinePropertiesChanged", pristineProperties, before);
    }

    _onUserSorted(sortData) {
        sortData = [].concat(sortData);
        let sort = {};

        sortData.forEach((sortData) => {
            if (!sortData || !sortData.sortColumn || !this.columnConfig[sortData.sortColumn]) {
                return;
            }
            const sortCriteria =
                this.columnConfig[sortData.sortColumn].valuePath ||
                this.columnConfig[sortData.sortColumn].path ||
                sortData.sortColumn;
            sort[sortCriteria] = sortData.sort === "asc" ? 1 : -1;
        });

        sort = this._patchSorting(sort);

        this._compPagingFeed.setSort(sort);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    get gameEditor() {
        return this._gameEditor;
    }

    get logger() {
        return this._logger;
    }

    whenModelIsReady() {
        return this._gameEditor
            .whenDeviceIsReady()
            .then(() => {
                this._device = this._gameEditor.getDevice();
                return this._device.loadRelatedEox({});
            })
            .then((eoxData) => {
                this._deviceEox = eoxData;
            })
            .then((results) => {
                this._componentEox = results;

                return Promise.resolve();
            })
            .then(() => {
                const userSorting = this._userGridData.getSorting() || {};
                const patchedSort = this._patchSorting(userSorting);
                const compList = this._device.componentEox;
                let EoxList = [];

                for (const property in compList) {
                    if (compList[property].pid) {
                        EoxList.push(compList[property].pid);
                    }
                }

                this._compEoxFilter = {name: {$in: EoxList}};

                this._compPagingFeed = new PagingCompEoxFeed({
                    feedKey: this._gridKey + "_feed",
                    userSession: this._userSession,
                    entityDef: this._device,
                    filter: this._compEoxFilter,
                    columnConfig: this.columnConfig,
                    additionalDataFields: [],
                    sort: patchedSort,
                });

                // Initialize phone model EoX feed
                const phoneModelList = this._device.detectedPhoneModels || {};
                this.phoneModelColumnConfig.model.context = {
                    detectedPhoneModels: phoneModelList,
                };
                let phoneModelEoxList = [];
                let phoneModelFeedPromises = [this._compPagingFeed.whenFeedReady()];

                for (const property in phoneModelList) {
                    if (phoneModelList[property].pid) {
                        phoneModelEoxList.push(phoneModelList[property].pid);
                    }
                }

                // Only create phone model feed if there's data
                if (phoneModelEoxList.length > 0) {
                    this._phoneModelEoxFilter = {name: {$in: phoneModelEoxList}};

                    this._phoneModelPagingFeed = new PagingPhoneModelEoxFeed({
                        feedKey: this._gridKey + "_phoneModel_feed",
                        userSession: this._userSession,
                        entityDef: this._device,
                        filter: this._phoneModelEoxFilter,
                        columnConfig: this.phoneModelColumnConfig,
                        additionalDataFields: [],
                        sort: patchedSort,
                    });
                    phoneModelFeedPromises.push(this._phoneModelPagingFeed.whenFeedReady());
                }

                this._registerListeners();
                return Promise.all(phoneModelFeedPromises);
            })
            .catch((err) => {
                const errorCode = err.errorCode;
                let errorMsg = "This EoX Bulletin cannot be opened.";

                switch (errorCode) {
                    case "NotAuthorized":
                        errorMsg = 'User not authorized for "View Device Vendor Support Data"';
                }
                this._logger.warn(err, "EoxBulletinViewComponent.whenModelIsReady() error");
                //NotAuthorized

                this._modalUserFeedback.displayError({
                    errorMsg: errorMsg,
                    errorCode: "",
                });
                console.log(err);
                return Promise.reject(err);
            });
    }

    getPagingFeed() {
        return this.compPagingFeed;
    }

    loadComponentEox() {
        const userSorting = this._userGridData.getSorting() || {};
        const patchedSort = this._patchSorting(userSorting);
        return this._device
            .loadRelatedComponentEoxes(this._compEoxFilter, undefined, patchedSort)
            .catch((err) => {
                this._logger.warn(err, "EoxBulletinViewComponent.loadComponentEox() error");
                this._modalUserFeedback.displayError({
                    errorMsg: "This EoX Component list cannot be opened.",
                    errorCode: "",
                });
                return Promise.reject(err);
            });
    }

    loadPhoneModelEox() {
        const userSorting = this._userGridData.getSorting() || {};
        const patchedSort = this._patchSorting(userSorting);
        return this._device
            .loadRelatedPhoneModelEoxes(this._phoneModelEoxFilter, undefined, patchedSort)
            .catch((err) => {
                this._logger.warn(err, "EoxBulletinViewComponent.loadPhoneModelEox() error");
                this._modalUserFeedback.displayError({
                    errorMsg: "This EoX Phone Model list cannot be opened.",
                    errorCode: "",
                });
                return Promise.reject(err);
            });
    }

    get pagingFeed() {
        return this._compPagingFeed;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = EoxBulletinViewComponent;

EoxBulletinViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.userSession",
    "$teve.entities.CustomFields",
    "$teve.ui.userFeedback",
    "$teve.storageFactory",
    "$teve.solutionsManager",
];

EoxBulletinViewComponent.$displayDetails = {
    type: "View",
    name: "EOX Bulletin",
    icon: "devicemanager.cisco_eox",
    shown: true,
    title: "EOX Bulletin",
    order: 4,
};
